import { Dialog } from "primereact/dialog";
import "./tenantModals.scss";
import CustomeButton from "~/components/Button";
import WarningIcon from "~/assets/unassign-icon.svg";

interface ExitConfirmationModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ExitConfirmationModal = ({
  visible,
  onCancel,
  onConfirm,
}: ExitConfirmationModalProps) => {
  const footerTemplate = () => {
    return (
      <div className="flex justify-content-center gap-2">
        <CustomeButton
          label="Cancel"
          variant="outlined"
          className="cancel-button"
          onClick={onCancel}
        />
        <CustomeButton
          label="Yes, Exit"
          variant="remove"
          className="exit-button"
          onClick={onConfirm}
        />
      </div>
    );
  };

  return (
    <Dialog
      visible={visible}
      style={{ width: "930px" }}
      onHide={onCancel}
      className="exit-confirmation-modal"
      footer={footerTemplate}
    >
      <div className="flex flex-column gap-3 align-items-center">
        <img src={WarningIcon} alt="Warning" className="exit-warning-icon" />
        <div className="flex flex-column gap-1 content">
          <div className="title m-0">
            Are you sure you want to exit without finishing registration?
          </div>
          <div className="description m-0">
            Exiting will erase your progress. Are you sure you want to archive
            it?
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ExitConfirmationModal;
